import { render } from "./WShadow.vue?vue&type=template&id=583a6a69&scoped=true"
const script = {}

import "./WShadow.vue?vue&type=style&index=0&id=583a6a69&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583a6a69"]])

export default __exports__